import { fg } from '@atlaskit/platform-feature-flags';
export var iconOnlySpacing = {
  '&&': {
    padding: '0px'
  },
  '& > span': {
    margin: '0px'
  }
};
var getStyles = function getStyles(property, _ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'default' : _ref$state,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'light' : _ref$mode;
  if (!property[appearance] || !property[appearance][state]) {
    return 'initial';
  }
  return property[appearance][state][mode];
};
var background = {
  danger: {
    default: {
      light: 'inherit',
      dark: 'inherit'
    },
    hover: {
      light: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
      dark: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    active: {
      light: "var(--ds-background-neutral-pressed, #080F214A)",
      dark: "var(--ds-background-neutral-pressed, #080F214A)"
    }
  }
};
var backgroundVisualRefresh = {
  danger: {
    default: {
      light: 'inherit',
      dark: 'inherit'
    },
    hover: {
      light: "var(--ds-background-danger-hovered, #FFD5D2)",
      dark: "var(--ds-background-danger-hovered, #FFD5D2)"
    },
    active: {
      light: "var(--ds-background-danger-pressed, #FFB8B2)",
      dark: "var(--ds-background-danger-pressed, #FFB8B2)"
    }
  }
};
var color = {
  danger: {
    default: {
      light: "var(--ds-icon, #292A2E)",
      dark: "var(--ds-icon, #292A2E)"
    },
    hover: {
      light: "var(--ds-icon-danger, #C9372C)",
      dark: "var(--ds-icon-danger, #C9372C)"
    },
    active: {
      light: "var(--ds-icon-danger, #C9372C)",
      dark: "var(--ds-icon-danger, #C9372C)"
    }
  }
};
var colorVisualRefresh = {
  danger: {
    default: {
      light: "var(--ds-icon-subtle, #505258)",
      dark: "var(--ds-icon-subtle, #505258)"
    },
    hover: {
      light: "var(--ds-icon-danger, #C9372C)",
      dark: "var(--ds-icon-danger, #C9372C)"
    },
    active: {
      light: "var(--ds-icon-danger, #C9372C)",
      dark: "var(--ds-icon-danger, #C9372C)"
    }
  }
};

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var getButtonStyles = function getButtonStyles(props) {
  return {
    background: getStyles(fg('platform-visual-refresh-icons') ? backgroundVisualRefresh : background, props),
    color: getStyles(fg('platform-visual-refresh-icons') ? colorVisualRefresh : color, props)
  };
};